import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { PopOver, usePopOver } from '@xingternal/pop-over';
import { Button } from '@xingternal/button';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';
import { Headline, BodyCopy } from '@xingternal/typography';
import { usePageContext } from '@xingternal/pages-common';

import { UPSELL_URL_EN, UPSELL_URL_DE } from './utils';

import styles from './EmployerBrandingFlag.css';
import { trackEmployerBrandingFlag } from '@xingternal/pages-tracking';

type ContentEmployerBrandingFlagProps = {
  hasImage: boolean;
};
export const ContentEmployerBrandingFlag: React.FC<ContentEmployerBrandingFlagProps> = ({
  hasImage,
}) => {
  const intl = useIntl();

  const handleOnClick = (ev: MouseEvent) => {
    ev.preventDefault();

    const tracking = hasImage
      ? '?sc_o= entity_page_companies_start_upsell_cover_image_module&sc_o_PropActionOrigin=entity_page_companies_upgrade_main_draft'
      : '?sc_o= entity_page_companies_start_upsell_cover_image_module&sc_o_PropActionOrigin=entity_page_companies_upgrade_main_none';

    let link = intl.locale === 'en' ? UPSELL_URL_EN : UPSELL_URL_DE;
    link = link + tracking;

    window.open(link);
  };

  return (
    <>
      {/* @ts-ignore */}
      <Headline
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: hasImage
              ? 'EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER_WITH_IMAGE'
              : 'EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER',
          }),
        }}
      />
      {/* @ts-ignore */}
      <BodyCopy
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: hasImage
              ? 'EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY_WITH_IMAGE'
              : 'EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY',
          }),
        }}
      />
      <Button
        className={styles.contentEmployerBrandingFlagButton}
        size="small"
        variant="proBusiness"
        onClick={handleOnClick}
        to={intl.locale === 'en' ? UPSELL_URL_EN : UPSELL_URL_DE}
      >
        <FormattedMessage id="EP_UPSELL_EMPLOYER_FLAG_CONTENT_BUTTON" />
      </Button>
    </>
  );
};

type EmployerBrandingFlagProps = {
  hasImage: boolean;
};
export const EmployerBrandingFlag: React.FC<EmployerBrandingFlagProps> = ({
  hasImage,
}) => {
  const { pageContext } = usePageContext();
  const popOver = usePopOver();

  const Icon = () => (
    <>
      {popOver.show ? (
        <IconArrowUp
          className={styles.iconEmployerBrandoingFlag}
          width="16"
          height="100%"
        />
      ) : (
        <IconArrowDown
          className={styles.iconEmployerBrandoingFlag}
          width="16"
          height="100%"
        />
      )}
    </>
  );

  return (
    <>
      <Button
        icon={Icon}
        iconAfter
        className={styles.employeBrandingFlag}
        onClick={() => {
          trackEmployerBrandingFlag({
            focusType: pageContext.focusType,
            draft: hasImage,
            itemId: pageContext.pageId,
          });
          popOver.togglePopOver();
        }}
        innerRef={popOver.triggerRef}
      >
        <FormattedMessage id="EP_UPSELL_EMPLOYER_FLAG_BUTTON" />
      </Button>
      <PopOver
        onOutsideClick={popOver.handleHide}
        show={popOver.show}
        offset={10}
        triggerRef={popOver.triggerRef}
        className={styles.contentEmployerBrandingFlag}
      >
        <ContentEmployerBrandingFlag hasImage={hasImage} />
      </PopOver>
    </>
  );
};

export default EmployerBrandingFlag;
